import React from 'react';
import TypingTest from '../components/TypingTest';

const TestPage = () => (
  <div className="min-h-screen py-8 px-4">
    <TypingTest />
  </div>
);

export default TestPage;
